import { Action } from '../typings/reducer'
import { AppStore } from '../typings/stores/AppStore'

export enum AppConstants {
  TRIGGER_ERROR = 'app/TRIGGER_ERROR',
  SHOW_ERROR = 'app/SHOW_ERROR',
}

export interface AppAction extends Action {
  type: AppConstants
  errors?: AppStore
  reference?: string
  message?: string
  index?: number
}

export function triggerError(message: string, reference?: string): AppAction {
  return {
    type: AppConstants.TRIGGER_ERROR,
    reference,
    message,
  }
}

export function showError(index: number): AppAction {
  return {
    type: AppConstants.SHOW_ERROR,
    index,
  }
}
